import React from 'react';
import {WeaLocaleProvider} from 'ecCom';
import Slider from 'react-slick';
import {WeaTools} from 'ecCom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';
import './css/index';
export default class Content_dataCenter extends React.Component {
    constructor(props) {
        super(props);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
    }

    onMouseOver(module){
        $(`#${module}`).css("background-image", "none");
        $(`#${module}`).find(".mtitle").show().css("padding-top", "52px");
        $(`#${module}`).css("opacity", '0.8')
    }

    onMouseMove(module){
        $(`#${module}`).css("background-image", "url(/images/homepage/portalcenter/" + module + "_wev8.png)");
        $(`#${module}`).find(".mtitle").hide();
        $(`#${module}`).css("opacity", '1')
    }

    render() {
        const {data = {}, eid} = this.props;
        const {moreLocal, iconMore} = data;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header data={data} eid={eid}/>
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div className="ant-row">
                                    <div className="ant-col-8">
                                        <div className="module workflow" data-type="workflow" id='workflow' onMouseOver={() => this.onMouseOver("workflow")} onMouseLeave={() => this.onMouseMove("workflow")}
                                             data-url="/spa/workflow/index_mobx.jsp#/main/workflow/listDoing?resourceid=1"
                                            style={{height: '120px'}}>
                                            <div className="num">122</div>
                                            <div className="mtitle">{getLabel(500431,'待办事宜') }</div>
                                        </div>
                                    </div>
                                    <div className="ant-col-8">
                                        <div className="ant-row">
                                            <div className="ant-col-12">
                                                <div className="module capital" data-type="capital" id='capital' onMouseOver={() => this.onMouseOver("capital")} onMouseLeave={() => this.onMouseMove("capital")}
                                                     data-url="/spa/cpt/index.html#/main/cpt/mycapital"
                                                     style={{backgroundColor: 'rgb(255, 210, 0)', height: '120px', backgroundImage: 'url(/images/homepage/portalcenter/capital_wev8.png)', opacity: 1}}>
                                                    <div className="num">0</div>
                                                    <div className="mtitle"
                                                         style={{display: 'none', paddingTtop: '52px'}}>{getLabel(30044,'资产') }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ant-col-12">
                                                <div className="module cowork" data-type="cowork" id='cowork' onMouseOver={() => this.onMouseOver("cowork")} onMouseLeave={() => this.onMouseMove("cowork")}
                                                     data-url="/spa/cowork/static/index.html#/main/cowork/hrmview?searchHrmid=1"
                                                     style={{backgroundColor: 'rgb(253, 144, 0)', height: '120px', backgroundImage: 'url(/images/homepage/portalcenter/cowork_wev8.png)', opacity: 1}}>
                                                    <div className="num">18</div>
                                                    <div className="mtitle"
                                                         style={{display: 'none', paddingTop: '52px'}}>{getLabel(17855,'协作') }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ant-col-8">
                                        <div className="module project" data-type="project" id='project' onMouseOver={() => this.onMouseOver("project")} onMouseLeave={() => this.onMouseMove("project")}
                                             data-url="/spa/prj/index.html#/main/prj/mineProject?search_resourceid=1"
                                             style={{backgroundColor: 'rgb(203, 97, 254)', height: '120px'}}>
                                            <div className="num">0</div>
                                            <div className="mtitle">{getLabel(1211,'我的项目') }</div>
                                        </div>
                                    </div>
                                    <div className="ant-col-8" style={{marginRight: '1px'}}>
                                        <div className="ant-row">
                                            <div className="ant-col-12">
                                                <div className="module crm" data-type="crm" id='crm' onMouseOver={() => this.onMouseOver("crm")} onMouseLeave={() => this.onMouseMove("crm")}
                                                     data-url="/spa/crm/static/index.html#/main/crm/customer/hrmView?searchHrmId=1"
                                                     style={{backgroundColor: 'rgb(104, 113, 227)', height: '120px'}}>
                                                    <div className="num">0</div>
                                                    <div className="mtitle">{getLabel(6059,'我的客户') }</div>
                                                </div>
                                            </div>
                                            <div className="ant-col-12">
                                                <div className="module blog" data-type="blog" id='blog' onMouseOver={() => this.onMouseOver("blog")} onMouseLeave={() => this.onMouseMove("blog")}
                                                     data-url="/spa/blog/static/index.html#/user/1"
                                                     style={{backgroundColor: 'rgb(86, 222, 115)', height: '120px'}}>
                                                    <div className="num">0</div>
                                                    <div className="mtitle">{getLabel(26468,'我的微博') }</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ant-col-8" style={{ marginLeft: '-1px'}}>
                                        <div className="module doc" data-type="doc" id='doc' onMouseOver={() => this.onMouseOver("doc")} onMouseLeave={() => this.onMouseMove("doc")}
                                             data-url="/spa/document/static/index.html#/main/document/search"
                                             style={{backgroundolor: 'rgb(253, 38, 119)', height: '120px', backgroundImage: 'url(/images/homepage/portalcenter/doc_wev8.png)', opacity: 1}}>
                                            <div className="num">5</div>
                                            <div className="mtitle"
                                                 style={{display: 'none', paddingTop: '52px'}}>{getLabel(1212,'我的文档') }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ant-col-8">
                                        <div className="ant-row">
                                            <div className="ant-col-12">
                                                <div className="module meetting" data-type="meetting" id='meetting' onMouseOver={() => this.onMouseOver("meetting")} onMouseLeave={() => this.onMouseMove("meetting")}
                                                     data-url="/spa/meeting/static/index.html#/main/meeting/CalView"
                                                     style={{backgroundColor: 'rgb(104, 113, 227)', height: '120px', backgroundImage: 'url(/images/homepage/portalcenter/meetting_wev8.png)', opacity: 1}}>
                                                    <div className="num">0</div>
                                                    <div className="mtitle"
                                                         style={{display: 'none', paddingTop: '52px'}}>{getLabel(2102,'我的会议') }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ant-col-12">
                                                <div className="module workplan" data-type="workplan" id='workplan' onMouseOver={() => this.onMouseOver("workplan")} onMouseLeave={() => this.onMouseMove("workplan")}
                                                     data-url="/spa/workplan/static/index.html#/main/wp/myWorkPlan"
                                                     style={{backgroundolor: 'rgb(203, 97, 254)', height: '120px', backgroundImage: 'url(/images/homepage/portalcenter/workplan_wev8.png)', opacity: 1}}>
                                                    <div className="num">0</div>
                                                    <div className="mtitle"C
                                                         style={{display: 'none', paddingTop: '52px'}}>{getLabel(18480,'我的日程') }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer" id={`footer_${eid}`} style={{textAlign: 'right'}}>
                    {moreLocal == 'footer' ? <a href="javascript:;"><img src={iconMore} alt=""/></a> : ''}
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_dataCenter.js